<template>
	<div>
		<insure-begin-notice
			ref="insureDialog"
			:insure-type="insureType"
			:inter-type="interType"
			:product-id="productId"
			@onNext="onNext"></insure-begin-notice>

		<profession-notice ref="noticeDialog" :insure-type="insureType" :product-id="productId"></profession-notice>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { mapGetters } from 'vuex'

import InsureBeginNotice from '@/views/insurance/product/insureBeginNotice.vue'
import ProfessionNotice from '@/views/insurance/product/professionNotice.vue'

export default {
	name: 'insureBeginHint',
	mixins: [],
	components: {ProfessionNotice, InsureBeginNotice},
	data() {
		return {
			insureType: '',
			productId: '',
			interType: -1,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {
		//展示弹窗
		showHint(insureType, productId, {informStatus = 0, informContent = ''}) {
			this.insureType = insureType
			this.productId = productId
			//弹窗
			this.interType = informStatus
			if (this.$refs.insureDialog) {
				this.$refs.insureDialog.showHint(informContent)
			}
		},
		onNext() {
			//延迟200毫秒
			setTimeout(() => {
				if (this.interType === 1) {
					//延迟500毫秒再弹出
					this.interType = 0
					if (this.$refs.insureDialog) {
						this.$refs.insureDialog.showHint()
					}
				} else {
					if (this.$refs.noticeDialog) {
						this.$refs.noticeDialog.showHint()
					}
				}
			}, 250)
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
}
</script>

<style lang="scss" scoped></style>
